/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RemoveCodesFromDbDto { 
    /**
     * Идентификатор рекламного предложения
     */
    productGroupId: string;
    /**
     * Номер партии загруженных кодов, если не указано - будет выбрана последняя загруженная партия кодов
     */
    partNumber?: number;
}

